import CAIA0040RequestModel from '@/api/data/CAI/CAIA0040/CAIA0040RequestModel'
import CAIA0040ResponseModel from '@/api/data/CAI/CAIA0040/CAIA0040ResponseModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'
import CommonUtil from '@/common/utils/CommonUtil'

export default class CAIG0040Service {
  /**
   * インターネット利用案内エリアの情報取得
   * @returns APIからのレスポンスデータ
   */
  public async callAPICAIA0040(): Promise<CAIA0040ResponseModel> {
    const caia0040RequestModel = new CAIA0040RequestModel()
    const caia0040ResponseModel: CAIA0040ResponseModel = <
      CAIA0040ResponseModel
    > await RestService.post(
      CommonUtil.getApiUrl(ApiUrlConstants.CAIA0040),
      caia0040RequestModel
    )
    return caia0040ResponseModel
  }
}
